module.exports = __webpack_public_path__ + "static/media/bombWhistle.faa59afd.mp3";